// 智慧场馆
import Url from '../utils/url';
export default {
  appName: 'wxapp_smartvenue',
  useKNB: false,
  sellChannel: 17,
  theme: 'maoyan',
  ajaxUrl: '//wx.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  getUserInfo: function getUserInfo() {
    return {
      token: Url.getQuery('_token') || Url.getHashQuery('_token')
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('_lat') || Url.getHashQuery('_lat'),
      lng: Url.getQuery('_lng') || Url.getHashQuery('_lng')
    };
  },
  getCity: function getCity() {
    return {
      cityId: Url.getQuery('_cityId') || Url.getHashQuery('_cityId')
    };
  }
};